export default "__VITE_ASSET__BicLTjQ0__ 584w";